<div class="allocation-dialog relative" *transloco="let t">
	<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="close(false)" [attr.aria-label]="t('commonActions.close')">
		<mat-icon>close</mat-icon>
	</button>
	<h3 cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="flex flex-row- justify-start items-center cursor-move" mat-dialog-title>
		{{ t('billing.assignAllocationTitle') }} {{ t('enum.' + this.costGroupType.category) }}
	</h3>
	<div class="flex flex-col">
		<mat-dialog-content mat-dialog-content>
			{{ t('billing.assignAllocationSubtitle') }}

			<div class="select-container flex flex-row justify-start items-center w-full gap-2">
				<mat-form-field appearance="outline" class="w-full">
					<mat-label>{{ t('billing.allocationSelect') }}</mat-label>
					<mat-select [(ngModel)]="selectedAllocation" class="w-full" name="selectedOption" panelClass="custom-select-options">
						<mat-select-trigger>
							{{ getAllocationName() }}
							@if (selectedAllocation()) {
								<mat-icon
									class="mat-select-clear-icon"
									[matTooltip]="t('commonActions.deleteSelection')"
									(click)="$event.stopPropagation(); selectedAllocation.set(undefined)"
									(keydown.enter)="$event.stopPropagation(); selectedAllocation.set(undefined)">
									clear
								</mat-icon>
							}
						</mat-select-trigger>
						@for (currentAllocation of allocations(); track currentAllocation) {
							<mat-option [value]="currentAllocation">
								<vex-allocation-option [allocation]="currentAllocation" />
							</mat-option>
						} @empty {
							{{ t('billing.assignAllocationNoData') }} {{ t('billing.allocationDefinition') }}
						}
					</mat-select>
				</mat-form-field>
			</div>
		</mat-dialog-content>
		<mat-dialog-actions class="flex flex-row justify-end items-center" mat-dialog-actions>
			<button (click)="close(true)" class="save-button m-2" color="primary" mat-raised-button>
				<mat-icon>save</mat-icon>
				@if (!layoutService.isMobile()) {
					<span>{{ t('commonActions.save') }}</span>
				}
			</button>
		</mat-dialog-actions>
	</div>
</div>
